import { TypographyProps } from '@mui/material'
import { Typography } from 'components/Material/index'
import { HardlineColor } from 'styles/useTextStyles'

interface HeadlineTextProps extends TypographyProps {
  text: string | number
  typeStyle: 'large' | 'small'
}

export const HeadlineText: React.FC<HeadlineTextProps> = ({ text, typeStyle, ...props }) => {
  return (
    <Typography sx={styles[typeStyle]} {...props}>
      {text}
    </Typography>
  )
}

const styles = {
  small: {
    fontSize: '24px',
    fontFamily: 'BB-Font-Regular',
    lineHeight: '32px',
    alignSelf: 'stretch',
    color: HardlineColor
  },
  large: {
    fontFamily: 'BB-Font-Bold',
    fontSize: '32px',
    lineHeight: '40px',
    color: HardlineColor
  }
}
